"use client";

import { size, theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import Image from "next/image";
import styled from "styled-components";
import imageContactUs from "/public/media/images/image-contactus.png";
import { breakpoints } from "@/utils/breakpoint";
import { useTranslations } from "next-intl";

const ContactUsBanner = () => {
    const t = useTranslations("ContactUsBanner");

    return (
        <SCContactUsBanner>
            <SCContactUsBannerContext>
                <div className="text-container">
                    <div className="text-small">{t("top-text")}</div>
                    <h1 className="text-xlarge">{t("main-text")}</h1>
                    <div className="text-medium">{t("bottom-text")}</div>
                </div>
                <div className="image-container">
                    <Image src={imageContactUs} alt="Swimming Classes" />
                </div>
            </SCContactUsBannerContext>
        </SCContactUsBanner>
    );
};

export default ContactUsBanner;

const SCContactUsBanner = styled.div`
    background-color: ${theme["color-light-purple"]};
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: ${theme["spacing-lxl"]} 0;
    margin-top: -80px;
    padding-top: 80px;
`;

const SCContactUsBannerContext = styled(SCContainerContent)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    // Mobile view
    ${breakpoints(
        "flex-direction",
        "",
        [{ [size.px.sxs]: "column" }],
        "max-width"
    )};

    > div {
        width: 40%;

        // Mobile view
        ${breakpoints("width", "", [{ [size.px.sxs]: "100%" }], "max-width")};
    }

    .text-container {
        .text-small {
            font-size: ${theme["fontsize-s"]};
            color: ${theme["color-blue"]};
        }

        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
        }

        .text-xlarge {
            font-size: ${theme["fontsize-xl"]};

            // Mobile view
            ${breakpoints(
                "font-size",
                "px",
                [{ [size.px.xs]: "35" }],
                "max-width"
            )};
        }

        > div {
            margin-bottom: ${theme["spacing-l"]};

            &:last-child {
                // Non-mobile view
                ${breakpoints(
                    "margin-bottom",
                    "",
                    [{ [(parseInt(size.px.sxs) + 1).toString()]: "0" }],
                    "min-width"
                )};
            }
        }
    }

    .image-container {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 400px;
            min-width: 300px;
            height: auto;

            // Mobile view
            ${breakpoints(
                "width",
                "",
                [{ [size.px.sxs]: "60%" }],
                "max-width"
            )};
        }
    }
`;
